import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { Button, SaveButton } from "../../../components/Buttons";

export const CloseAlert = () => {
    document.title = "Bağla xəbərdarlıq";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Ümumi anlayışlar", value: "/common" },
        { name: "Bağla xəbərdarlıq", value: "/common/closealert", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Bağla xəbərdarlıq</h2>
                    <p>
                        <ol>
                            <li>
                                Məhsula və ya hər hansı əməliyyata edilmiş dəyişiklikləri yadda saxlamadan <Button>Bağla</Button> düyməsini sıxanda,
                                istifadəçiyə dəyişikliklərin saxlanılması barədə xəbərdarlıq edilir
                            </li>
                            <li>
                                <Button>Ok</Button> düyməsini sıxanda dəyişikliklər yadda saxlanılmayacaq və sənəd bağlanacaq
                            </li>
                            <li>
                                <SaveButton /> düyməsini sıxanda dəyişikliklər yadda saxlanılacaq
                            </li>
                            <li>
                                <Button>Geri qayıt</Button> düyməsini sıxanda dəyişikliklərə əlavə olunması üçün yenidən səhifə açılacaq
                            </li>
                        </ol>
                    </p>
                    <img src="/images/common/closealert.gif" alt="Bağla xəbərdarlıq" />
                </article>
            </div>
        </div>
    );
};
